<script setup>
import CheckContourViewer from '@src/components/CheckContourViewer.vue';
</script>

<template>
  <div class="w-full h-full">
    <div class="viewers-tools-container gap-2">
      <CheckContourViewer viewer-i-d="ContoursLeft" title="OCG QA #1" />

      <CheckContourViewer viewer-i-d="ContoursRight" title="OCG QA #2" />
    </div>
  </div>
</template>

<style scoped>
.viewers-tools-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 100%;
  justify-content: center;
  min-width: 0;
}

.viewers-tools-container > * {
  min-width: 0; /* Ensures grid items can shrink below content size */
  overflow: hidden; /* Prevents overflow */
}

/* TODO: Use the vue viewport breakpoints */
@media (max-width: 1024px) {
  .viewers-tools-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
}
</style>
